import React from 'react';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Box, Link } from '../../../design-system';
import { colors } from '../../../design-system/colors';

const FooterSocial: React.FC = () => {
  return (
    <Box
      component="nav"
      sx={{
        display: 'flex',
        gap: '0.5rem',
        alignItems: 'center',
      }}
      aria-label="Social media links"
    >
      <Link
        href="https://twitter.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit our Twitter page"
        sx={{ color: colors.neutral.white, '&:hover': { color: colors.primary[500] } }}
      >
        <TwitterIcon />
      </Link>
      <Link
        href="https://facebook.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit our Facebook page"
        sx={{ color: colors.neutral.white, '&:hover': { color: colors.primary[500] } }}
      >
        <FacebookIcon />
      </Link>
      <Link
        href="https://instagram.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit our Instagram page"
        sx={{ color: colors.neutral.white, '&:hover': { color: colors.primary[500] } }}
      >
        <InstagramIcon />
      </Link>
      <Link
        href="https://linkedin.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit our LinkedIn page"
        sx={{ color: colors.neutral.white, '&:hover': { color: colors.primary[500] } }}
      >
        <LinkedInIcon />
      </Link>
    </Box>
  );
};

export default FooterSocial;
